/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fine_Day_Fish_BakeInputs */

const en_fine_day_fish_bake = /** @type {(inputs: Fine_Day_Fish_BakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/de/category/arbeiten-mit-ergebnissen-1i6hcnj/`)
};

const de_fine_day_fish_bake = /** @type {(inputs: Fine_Day_Fish_BakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/de/category/arbeiten-mit-ergebnissen-1i6hcnj/`)
};

/**
* | output |
* | --- |
* | "https://help.kultify.com/de/category/arbeiten-mit-ergebnissen-1i6hcnj/" |
*
* @param {Fine_Day_Fish_BakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fine_day_fish_bake = /** @type {((inputs?: Fine_Day_Fish_BakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fine_Day_Fish_BakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fine_day_fish_bake(inputs)
	return de_fine_day_fish_bake(inputs)
});